'use client';

import { jsx } from "react/jsx-runtime";
import { memo, forwardRef } from "react";
import { MenuItemAsAnchor } from "./MenuItem.AsAnchor.js";
import { MenuItemAsButton } from "./MenuItem.AsButton.js";
function MenuItemComponent(props, ref) {
  if ("href" in props) {
    return /* @__PURE__ */ jsx(
      MenuItemAsAnchor,
      {
        ...props,
        ref
      }
    );
  }
  return /* @__PURE__ */ jsx(MenuItemAsButton, { ...props, ref });
}
const MenuItem = (
  /* #__PURE_ */
  memo(forwardRef(MenuItemComponent))
);
export {
  MenuItem
};
